export default __webpack_public_path__ + "static/media/feather_menu.eae33c67.svg";